import { useEffect } from "react";
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { forceLogout } from "../middleware/auth/index.js";

const CHECK_INTERVAL_MS = 60 * 1000;

const useTokenExpiryWatcher = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    let intervalId = null;

    const handleExpiration = () => {
      forceLogout(dispatch);
    };

    const checkToken = () => {
      const token = sessionStorage.getItem("token") || localStorage.getItem("token");

      if (!token) {
        return;
      }

      try {
        const { exp } = jwt_decode(token);
        if (exp * 1000 <= Date.now()) {
          handleExpiration();
        }
      } catch (error) {
        handleExpiration();
      }
    };

    checkToken();
    intervalId = window.setInterval(checkToken, CHECK_INTERVAL_MS);

    return () => {
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, [dispatch]);
};

export default useTokenExpiryWatcher;
